<div class="odm-tab-view">
  <div class="tab-navigation">
    <div class="tab-arrow tab-arrow-left"
         (click)="scrollTabs('left', tabListContainer)"
         [class.hidden]="!canScrollLeft">
      <img src="assets/images/sidebar/chevron-left.svg" alt="Previous tabs" class="arrow-icon arrow-icon-left">
    </div>
    <div class="tab-arrow tab-arrow-right"
         (click)="scrollTabs('right', tabListContainer)"
         [class.hidden]="!canScrollRight">
      <img src="assets/images/customer/chevron-right.svg" alt="Next tabs" class="arrow-icon arrow-icon-right">
    </div>

    <div class="tab-list-container"
         #tabListContainer
         (scroll)="onScroll(tabListContainer)">
      <div class="tab-list">
        <div *ngFor="let t of tabs; let i = index; trackBy: trackByIndex"
             class="tab-item"
             [attr.data-tab-id]="t.id"
             [class.active]="activeTabId === t.id"
             [class.completed]="getTabState(t.id) === 'completed'"
             [class.disabled]="getTabState(t.id) === 'disabled'"
             [class.accessible]="getTabState(t.id) === 'accessible'"
             [style.pointer-events]="'none'">
          <div class="tab-content">
            <span class="tab-index" [class.completed-icon]="getTabState(t.id) === 'completed'">
              <span *ngIf="getTabState(t.id) !== 'completed'">{{ i + 1 }}</span>
              <div *ngIf="getTabState(t.id) === 'completed'" class="checkmark-circle">
                <svg width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7 1L3 5L1 3"
                        stroke="currentColor"
                        stroke-width="1.2"
                        stroke-linecap="round"
                        stroke-linejoin="round"/>
                </svg>
              </div>
            </span>
            <span class="tab-label">{{ t.label }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
